import React from 'react'
import { View, Row, Column, Intro } from 'components/Layout'
import Telescope from '../../assets/intros/telescope.svg'

const Page404 = () => {
	return (
		<View>
			<Row topMargin center>
				<Column width={2}>
					<Telescope width={190} />
				</Column>
				<Column width={3}>
					<Intro
						header={'404. Whoops.'}
						body={'There is no such a page.'}
					/>
				</Column>
			</Row>
		</View>
	)
}
export default Page404



// WEBPACK FOOTER //
// ./src/views/Common/Page404.js